import React, { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { getToken } from './pilotageApi';
import AdminNav from '../admin/AdminNav';
import './pilotage.css';

// Shell du Pilotage (Mission 3, Lot 7) — utilise le MÊME menu unique (`AdminNav`)
// que le reste de l'administration : une seule navigation, plus de double admin.
// La zone de contenu conserve le style clair « .pilotage » propre aux écrans cockpit.
export default function PilotageLayout() {
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    if (!getToken()) nav('/connexion', { replace: true });
  }, [nav, loc.pathname]);

  return (
    <div className="pilotage">
      <aside data-theme="admin-dark" data-testid="pilotage-rail"
        style={{ width: 240, flex: '0 0 240px', height: '100vh', position: 'sticky', top: 0, overflowY: 'auto' }}>
        <AdminNav />
      </aside>
      <div className="main">
        <Outlet />
      </div>
    </div>
  );
}
